"use client"

import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef<
  React.ComponentRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-gray-200">
      <SliderPrimitive.Range className="absolute h-full bg-gail-primary" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-[22px] w-[22px] cursor-pointer rounded-full border-2 border-gail-primary bg-white shadow-[0_1px_4px_rgba(0,0,0,0.15)] transition-all hover:shadow-[0_0_0_6px_rgba(0,98,226,0.12)] hover:scale-[1.08] active:shadow-[0_0_0_8px_rgba(0,98,226,0.18)] active:scale-[1.12] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gail-primary disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
